module.exports = __webpack_public_path__ + "static/media/photo13.218428f9.jpg";